import { ReactElement } from 'react'
import images from 'const/images'
import { customComponents } from 'configureBrand'
import { useShallowEqualSelector } from 'redux/hooks'
import { selectOfferPromo } from 'redux/dynamicContent/dynamicContentSlice'
import { AnalyticsEvent } from 'helpers/analytics'
import DefaultOfferInfo from './DefaultOfferInfo'

/**
 * Component used to display promotional link and image which may be customized
 * by the brand.
 */
const ClientOffering = (): ReactElement => {
  const { url, text } = useShallowEqualSelector(selectOfferPromo)

  const { offerBanner } = images
  const { CustomOfferInfo } = customComponents

  return CustomOfferInfo ? (
    <CustomOfferInfo
      offerBanner={offerBanner}
      offerPromoUrl={url}
      offerText={text}
      dataObject="banner"
      dataReason="Landing page banner"
      dataType="banner"
      dataAnalytics={AnalyticsEvent.click}
    />
  ) : (
    <DefaultOfferInfo />
  )
}

export default ClientOffering
